export default "__VITE_ASSET__OqcIUexw__"